import { render, staticRenderFns } from "./AuthoritativeGuideDialog.vue?vue&type=template&id=53599d8a&scoped=true"
import script from "./AuthoritativeGuideDialog.vue?vue&type=script&lang=js"
export * from "./AuthoritativeGuideDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53599d8a",
  null
  
)

export default component.exports